import React from "react";
import VisiteMediche from "./VisiteMediche";

export default function ImpostazioneTerapie() {
  return <VisiteMediche modo="terapie" />;
}
